// extracted by mini-css-extract-plugin
export default {"label":"Label_label__N6qr6","editable":"Label_editable__f+7vZ","selected":"Label_selected__Iwt6H"};